import { tv } from 'tailwind-variants'

export const switchCard = tv({
  slots: {
    container: 'gap-y-4 rounded-lg border border-ui-grey-500 p-4 web:grid web:grid-flow-row',
    iconContainer: 'flex h-12 w-12 items-center justify-center rounded-full bg-brand-dark/5',
    btn: 'ios:active:opacity-70 android:active:opacity-70 mt-2.5 flex flex-row items-center hover:opacity-70 web:transition web:duration-300',
    label: 'flex flex-row items-center',
    textContainer: 'flex-1 px-4',
  },
})
